export function debounce(delay, callback) {
  let lastTime;

  // eslint-disable-next-line func-names
  return function () {
    clearTimeout(lastTime);
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    const [that, args] = [this, arguments];
    lastTime = setTimeout(() => {
      callback.apply(that, args);
    }, delay);
  };
}

export function observerDomResize(dom, callback) {
  const MutationObserver = window.MutationObserver
    || window.WebKitMutationObserver || window.MozMutationObserver;
  const observer = new MutationObserver(callback);
  observer.observe(dom, { attributes: true, attributeFilter: ['style'], attributeOldValue: true });
  return observer;
}

export function uuid(hasHyphen) {
  return (hasHyphen ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx').replace(
    /[xy]/g,
    (c) => {
      // eslint-disable-next-line no-bitwise
      const r = Math.random() * 16 | 0;
      // eslint-disable-next-line no-bitwise, no-mixed-operators
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    },
  );
}
